import { motion } from 'framer-motion';
import Coin from '../../../assets/svg/utils/coins/coin-ltr.svg';
import { formatNumbers } from '../../../helpers';
import { useAppSelector } from '../../../store';
import { useAnimatedCounter } from '../../../hooks/useAnimatedCounter';

function CoinsInfo() {
  const { userData } = useAppSelector(
    ({ profile }) => profile,
  );
  const { counter, isPulsing, isBlinking } = useAnimatedCounter(userData?.coins || 0);
  return (
    <div className="header-coin-card gradient-border bg-headerCoinsBG h-[33px] min-w-[79px] pl-[27px] rounded-8 before:rounded-8 relative flex justify-start items-center pr-1 ml-[18px]">
      <div
        className="absolute left-[-20%] top-[-1px]"
        style={{
          filter: 'drop-shadow(0px 17.46px 17.46px #FFC85366)',
        }}
      >
        <img
          src={Coin}
          alt="coin-icon"
          className="h-[38px]"

        />
      </div>
      <div className="font-Bangers text-base pr-2">
        <motion.div
          initial={{ scale: 1 }}
          animate={{
            scale: isPulsing ? [1, 1.2, 1] : 1,
            opacity: isBlinking ? [1, 0, 1] : 1,
          }}
          transition={{
            duration: (isPulsing || isBlinking) ? 0.5 : 0,
            ease: 'easeInOut',
            // eslint-disable-next-line no-nested-ternary
            repeat: isPulsing ? Infinity : isBlinking ? 4 : 0,
            repeatType: 'loop',
            times: [0, 0.5, 1],
          }}
        >
          {formatNumbers(counter, 2)}
        </motion.div>
      </div>
    </div>
  );
}

export default CoinsInfo;
